import { useMemo } from 'react';

const adjustHex = (hex: string, factor: number) => {
    hex = hex.replace(/^#/, '');

    let r = parseInt(hex.substring(0, 2), 16);
    let g = parseInt(hex.substring(2, 4), 16);
    let b = parseInt(hex.substring(4, 6), 16);

    if (factor < 1) {
        r = Math.round(r * factor);
        g = Math.round(g * factor);
        b = Math.round(b * factor);
    }

    if (factor >= 1) {
        r = Math.round(r + (255 - r) * (factor - 1));
        g = Math.round(g + (255 - g) * (factor - 1));
        b = Math.round(b + (255 - b) * (factor - 1));
    }

    return '#' + r.toString(16).padStart(2, '0') + g.toString(16).padStart(2, '0') + b.toString(16).padStart(2, '0');
};

export const useBrandedColors = ({ brandColor = '#00807b' }: { brandColor?: string }) => {
    const useBrandedColorsBool = useMemo(() => brandColor !== '#00807b', [brandColor]);
    const brandedBase = useMemo(() => brandColor || '#00807b', [brandColor]);
    const brandedDarker = useMemo(() => (brandColor === '#00807b' ? '#006464' : adjustHex(brandColor, 0.8)), [brandColor]);
    const brandedLighter = useMemo(() => (brandColor === '#00807b' ? '#006965' : adjustHex(brandColor, 1.4)), [brandColor]);

    const getStyle = () => {
        if (!brandColor) {
            return;
        }

        return {
            '--brand-base': brandColor,
            '--brand-darker': brandedDarker,
        } as React.CSSProperties;
    };

    return {
        useBrandedColorsBool,
        brandedBase,
        brandedDarker,
        brandedLighter,
        getStyle,
    };
};
